import React, { createContext, useReducer,useEffect } from "react";
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
const ProfileContext = createContext();

// const Profile={
//   first_name:"Yabsera",
//   middle_name:"Haile",
//   last_name:"Yemaneberhan",
//   college:"College of Electrical and Mechanical Engineering",
//   dep:"Software Engineering",
//   rank:"PHD",
//   mobile:"+251987654321",
//   pic:"/images/photo.png",
//   email:"yabserahaile@gmail.com",
//   calendar:{
//     year:"2022",
//     semester:"II",
//     duration:"Dec 20,2022 - May 3,2022",
//     n_weeks:"16",
//   },
//   details:{
//     load: 17,
//     n_groups:4,
//     a_research:3,
//     expectedLoad:12,
//     payment_rate:100,
//     leh:40,
//   }
// }
const Profile={
  first_name:"",
  middle_name:"",
  last_name:"",
  college:"",
  dep:"",
  rank:"",
  mobile:"",
  pic:"",
  email:"",
  host:"",
  calendar:{
    year:"",
    semester:"",
    duration:"",
    start_date:"",
    end_date:"",
    n_weeks:"",
  },
  details:{
    load: 0,
    n_groups:0,
    a_research:0,
    expectedLoad:0,
    payment_rate:0,
    position_load:0,
    research_load:0,
    academic_load:0,
    leh:0,
  }
}
const reducer = (state, action) => {
  switch (action.type) {
    case "load_profile":
      return action.payload
    case "edit_profile":
      return 
    default:
      return new Error();
  }
};



export function ProfileContextProvider({ children }) {
  const {changed}=useAuth();
  const api=useAxiosPrivate()
  const [state, dispatch] = useReducer(reducer, Profile);
  useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`profile/view/`,{
            signal:controller.signal
          })
          isMounted &&  dispatch({type:"load_profile",payload:response.data})}
        catch(err){
          console.error(err)
        }
      }
      getData();
      return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[changed,api])
    // console.log(changed)
  return (
    <ProfileContext.Provider value={{ state, dispatch }}>
      {children}
    </ProfileContext.Provider>
  );
}

export default ProfileContext;